import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import useStore from "../../store/useStore";
import {
  BriefcaseIcon,
  PaperPlaneTiltIcon,
  XIcon,
} from "@phosphor-icons/react";
import {
  DEFAULT_EMAIL_CONTENT,
  DEVELOPMENT_AND_DESIGN,
  JOB_OFFER,
  SERVICE,
} from "../../enums/enums";
import { JobOfferForm } from "../forms/JobOfferForm";
import { ServicesForm } from "../forms/ServicesForm";
import { useFormik } from "formik";
import { BasicEmailForm } from "../forms/BasicEmailForm";
import { object } from "yup";
import {
  basicEmailDetailsValidation,
  jobOfferValidation,
  serviceValidation,
} from "../validations/formValidations";
import { handleSendEmail } from "../helpers/emailHelper";

export const EmailDialog = () => {
  const {
    emailDialogStatus,
    emailDialogType,
    serviceType,
    setEmailDialogStatus,
    setEmailDialogType,
    setServiceType,
  } = useStore();

  const handleCloseDialog = () => {
    setEmailDialogStatus(false);
    setEmailDialogType(JOB_OFFER);
    setServiceType(DEVELOPMENT_AND_DESIGN);
  };

  const formik = useFormik({
    initialValues: {
      ...DEFAULT_EMAIL_CONTENT,
      inquiry_type: emailDialogType,
      ...(emailDialogType === SERVICE ? { service_type: serviceType } : {}),
    },
    enableReinitialize: true,
    validateOnBlur: false,
    validateOnChange: false,
    validationSchema: object().shape({
      ...basicEmailDetailsValidation,
      ...(emailDialogType === SERVICE
        ? { ...serviceValidation }
        : { ...jobOfferValidation }),
    }),
    onSubmit: (values, { setSubmitting, resetForm }) => {
      const params = {
        ...values,
      };
      handleSendEmail(params, resetForm).finally(() => {
        setSubmitting(false);
        handleCloseDialog();
      });
    },
  });

  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("md"));

  return (
    <Dialog fullScreen={isMobile} open={emailDialogStatus} fullWidth>
      <DialogTitle>
        <Stack
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Stack direction={"row"} gap={1} alignItems={"center"}>
            <BriefcaseIcon size={22} weight="bold" />
            <Typography variant="h6" fontWeight={600}>
              Hire Me
            </Typography>
          </Stack>
          <IconButton onClick={handleCloseDialog}>
            <XIcon size={20} />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <Typography fontWeight={700} variant="h6" color="primary.main">
          Start by sending an email!
        </Typography>
        <Typography variant="caption">
          The journey to something great starts with a message
        </Typography>
        {/* Email options selection removed */}
        <Stack gap={2} mt={2}>
          <BasicEmailForm formik={formik} />
          <JobOfferForm formik={formik} />
          {/* {emailDialogType === JOB_OFFER ? <JobOfferForm formik={formik} /> : <ServicesForm formik={formik} />} */}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ pb: 3, pr: 3 }}>
        <Button variant="outlined" onClick={handleCloseDialog}>
          Cancel
        </Button>
        <Button
          variant="contained"
          startIcon={<PaperPlaneTiltIcon size={16} weight="bold" />}
          onClick={() => formik.handleSubmit()}
          disabled={formik.isSubmitting}
        >
          {formik.isSubmitting ? "Submitting..." : "Submit"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
